import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa'; // Import social media icons
import logo from '../assets/logo/MC_2607_Logo-02.png';

function Footer() {
  const lineRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    };

    const lineElement = lineRef.current;
    const elements = document.querySelectorAll('.animation-footer-text');

    const observer = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          lineElement.classList.add('animated-line');

        } else {
          lineElement.classList.remove('animated-line');
        }
      });
    }, options);

    // Start observing the line element
    observer.observe(lineElement);

    // Clean up observer when component unmounts
    return () => {

      if (lineElement) {
        observer.unobserve(lineElement);
      }
    };
  }, []);



  return (
    <>
      <footer className="relative md:w-full bg-mcare-green text-white md:py-16 pt-10 pb-16 shadow-footer ">
        <div className='bg-black/60 absolute inset-0 z-0' />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 relative">

          <div className="flex flex-col ">
            <img src={logo} className="bg-contain w-[15rem]   mb-8 pl-10" alt="logo mcare" />
            <div className="w-full flex px-10 text-center z-20  pb-4">
              <a href="https://www.instagram.com/mcare_fisio_sportclinic?igsh=cDN6enAybXV2YjVr" target='blank' className={`md:text-4xl text-2xl md:m-0 hover:text-white/50 `} ><FaInstagram /></a>
              <a href="https://www.facebook.com/profile.php?id=61561510323794" target='blank' className={`md:text-4xl text-2xl px-3 md:m-0 hover:text-white/50 `} ><FaFacebook /></a>
            </div>
            <p className={`w-full text-sm md:text-lg px-10`}>Reperibilità telefonica dalle 08.00 alle 09.00 e dalle 20.00 alle 21.00</p>

            <div className="w-full pt-5">
              <p className="mx-auto text-white px-10 md:text-lg"><em className='font-semibold'>Contattaci, siamo a tua completa disposizione per fornirti tutta l'assistenza e la consulenza di cui hai bisogno.</em></p>
            </div>
          </div>

          {/* VERONA */}
          <div className='flex flex-col justify-center'>
            <div className={`px-10`}>
              <p className="text-2xl font-bold mb-4" alt="logo mcare" >Verona</p>
              <p className={`text-sm md:text-lg`}>Via Enrico Fermi, 13/A, CAP. 37135, Verona (VR)</p>
              <p className={`text-sm md:text-lg`}>C.f. e P.IVA 05003310231</p>
              <p className={`w-full text-sm md:text-lg`}>Email: info@mcarefisio.it</p>

              <p className={`text-sm md:text-lg`}>Tel. 0459856026 - Cell. +39 320 2474886</p>
              <div className="mt-4">
                <p>Orario di apertura:</p>
                <ul>
                  <li>
                    Lunedì - Venerdì: 9:00 - 20:00
                  </li>
                  <li>
                    Sabato: 9:00 - 12:00
                  </li>
                  <li>
                    Domenica: Chiuso
                  </li>
                </ul>
              </div>

            </div>
          </div>

          {/* SONA */}
          <div className='flex flex-col justify-center'>
            <div className={`px-10`}>
              <p className="text-2xl font-bold mb-4" alt="logo mcare" >Sona</p>
              <p className={`text-sm md:text-lg `}>Via Toscana, 13, CAP. 37060, Sona (VR)</p>
              <p className={`text-sm md:text-lg`}>C.f. e P.IVA 05158060235 </p>
              <p className={`w-full text-sm md:text-lg`}>Email: sona@mcarefisio.it</p>

              <p className={`text-sm md:text-lg`}>Cell. +39 353 2137757</p>
              <div className="mt-4">
                <p>Orario di apertura:</p>
                <ul>
                  <li>
                    Lunedì - Venerdì: 9:00 - 20:00
                  </li>
                  <li>
                    Sabato: Chiuso
                  </li>
                  <li>
                    Domenica: Chiuso
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div>

          </div>
        </div>
        <hr ref={lineRef} className="border-b border-white/50 my-4" />

        <div className="flex flex-wrap justify-center md:space-x-8 relative">
          <Link to='/privacypolicy' className={`text-sm me-3 mt-3 md:m-0 hover:text-white/50 `} >Privacy Policy</Link>
        </div>

      </footer>
    </>
  );
}

export default Footer;
